/**
 * Detail page loader
 */
import { JsonReader } from '../../imports/jsonReader';
import changeTitle from '../../imports/changeTitle';

const detailLoader = () => {
  const jsonFileContents = new JsonReader('./Assets/media/data/dataFile.json');
  const imagePath = './Assets/media/img/detail/';
  const tagDescription = document.querySelector('.js-tagdescription');
  
  function scrollDown(id:string) {
    let item  = document.querySelector('#' + id);
    item?.scrollIntoView();
  }

  function setContent(category:string, contentList:any, id = '') {
    let jsTagDetails = [] as any;
    changeTitle(category);

    jsonFileContents.getByCategory(category)
      .then( jsonData => {
        if (jsonData.length > 0) {
          contentList.innerHTML = '';

          jsonData.forEach( (element:any) => {
            if (element.clone == null || element.clone != true) {
              // Create base element
            let elemItem = document.createElement('div');
            elemItem.classList.add('detail__item', 'js-content-item');
            
            // Add anchor tag
            let elemAnchor = document.createElement('a');
            let categLength = document.querySelector('.js-detailfilter') as any;
            categLength = categLength ? categLength.offsetHeight : 0;
            elemAnchor.classList.add('anchor', 'anchor--detail', 'js-content-id');
            elemAnchor.setAttribute('id', element.id);
            elemAnchor.style.top = (-50 + (categLength * -1)) + 'px';
            elemItem.append(elemAnchor);

            // Add Title component
            let elemTitle = document.createElement('div');
            elemTitle.classList.add('section__title-type2');
            let elemTitleText = document.createElement('h2');
            elemTitleText.classList.add('section__title-text', 'section__title-text--type2');
            if (element.displayname != '' && element.displayname != null) {
              elemTitleText.innerHTML = element.displayname;
            } else {
              elemTitleText.innerHTML = element.name;
            }
            elemTitle.append(elemTitleText);
            elemItem.append(elemTitle);

            // Taglist
            if ( element.familyname || element.lifecycle ) {
              let elemTagContent = document.createElement('ul');
              elemTagContent.classList.add('detail__taglist');
              if (element.familyname) {
                let elemTagName = document.createElement('li');
                elemTagName.classList.add('detail__tag');
                elemTagName.innerHTML = element.familyname;
                elemTagContent.append(elemTagName);
              }

              // Tags
              if (element.lifecycle) {
                let elemCycle = document.createElement('ul');
                elemCycle.classList.add('detail__taglist-sublist');

                if (element.lifecycle == '1年生または多年生') {
                  let elemCycleItem = document.createElement('li');
                  elemCycleItem.classList.add('detail__tag', 'detail__tag--grade');
                  elemCycleItem.innerHTML = '1年生';
                  elemCycle.append(elemCycleItem);

                  elemCycleItem = document.createElement('li');
                  elemCycleItem.classList.add('detail__tag', 'detail__tag--or');
                  elemCycleItem.innerHTML = 'または';
                  elemCycle.append(elemCycleItem);

                  elemCycleItem = document.createElement('li');
                  elemCycleItem.classList.add('detail__tag', 'detail__tag--grade', 'blue' );
                  elemCycleItem.innerHTML = '多年生';
                  elemCycle.append(elemCycleItem);
                } else if (element.lifecycle == '多年生') {
                  let elemCycleItem = document.createElement('li');
                  elemCycleItem.classList.add('detail__tag', 'detail__tag--grade', 'blue' );
                  elemCycleItem.innerHTML = '多年生';
                  elemCycle.append(elemCycleItem);
                } else {
                  let elemCycleItem = document.createElement('li');
                  elemCycleItem.classList.add('detail__tag', 'detail__tag--grade');
                  elemCycleItem.innerHTML = element.lifecycle;
                  elemCycle.append(elemCycleItem);
                }
                elemTagContent.append(elemCycle);
              }
              elemItem.append(elemTagContent);
            }
            
            // Taglist simple
            if (element.tags && element.tags.length > 0) {
              let elemTagContent = document.createElement('ul');
              elemTagContent.classList.add('detail__taglist', 'detail__taglist--simple');
              
              element.tags.forEach((element_tag:any) => {
                let elemCycleItem = document.createElement('li');
                elemCycleItem.classList.add('detail__tag', 'detail__tag--simple');
                if (element_tag.addclass && element_tag.addclass.length > 0) {
                  elemCycleItem.classList.add(...element_tag.addclass);
                }
                elemCycleItem.innerHTML = element_tag.name;
                elemTagContent.append(elemCycleItem);
                jsTagDetails.push(element_tag);
              });
              elemItem.append(elemTagContent);

              // Filter all the tags used
              jsTagDetails = jsTagDetails.filter((value:any, index:any, self:any) =>
                index === self.findIndex((t:any) => (
                  t.place === value.place && t.name === value.name
                ))
              );
            }
            
            // Content
            if ( element.ecology ) {
              let elemEcology = document.createElement('p');
              elemEcology.classList.add('detail__text', 'detail__text--details');
              elemEcology.innerHTML = element.ecology;
              elemItem.append(elemEcology);
            }

            // Detail Guide
            if (element.dataimage.length > 0) {
              let elemDataimage = document.createElement('ul');
              elemDataimage.classList.add('detail__guide');

              element.dataimage.forEach( (element2:any) => {
                let elemDataItem = document.createElement('div');
                elemDataItem.classList.add('detail__guide-item');

                if (element2.imagepath) {
                  let elemImageContainer = document.createElement('div');
                  elemImageContainer.classList.add('detail__guide-image');
                  let elemImageFile = document.createElement('img');
                  elemImageFile.classList.add('image', 'image--100', 'image--contain', 'lazy');
                  elemImageFile.setAttribute('src', imagePath + element2.imagepath);
                  elemImageContainer.append(elemImageFile);
                  elemDataItem.append(elemImageContainer);
                }

                if (element2.description) {
                  let elemImageText = document.createElement('div');
                  elemImageText.classList.add('detail__guide-description');
                  let elemImageTextSpan = document.createElement('span');
                  elemImageTextSpan.classList.add('detail__text');
                  elemImageTextSpan.innerHTML = element2.description;
                  elemImageText.append(elemImageTextSpan);
                  elemDataItem.append(elemImageText);
                }
                elemDataimage.append(elemDataItem);
              });
              elemItem.append(elemDataimage);
            }
            
            // Remarks
            if (element.remarks) {
              let remarks = document.createElement('div');
              remarks.classList.add('detail__remarks');
              
              if (element.remarks.text) {
                let remarksTitle = document.createElement('h3');
                remarksTitle.classList.add('detail__remarks-title');
                remarksTitle.innerHTML = element.remarks.text;
                remarks.append(remarksTitle);
              }

              if (element.remarks.details.length > 0 ) {
                let remarksList = document.createElement('ul');
                remarksList.classList.add('detail__remarks-list');
                if (element.remarks.addclass) {
                  remarksList.classList.add(...element.remarks.addclass);
                }

                element.remarks.details.forEach( (element2:any) => {
                  let remarksItem = document.createElement('li');
                  remarksItem.classList.add('detail__remarks-item');

                  if ( element2.imagepath ) {
                    let remarksImg = document.createElement('img');
                    remarksImg.setAttribute('src', imagePath + element2.imagepath);
                    remarksImg.classList.add('image');
                    remarksImg.classList.add('image--100');
                    remarksImg.classList.add('lazy');
                    remarksImg.classList.add('detail__remarks-image');
                    remarksItem.append(remarksImg);
                  }
                  if ( element2.text ) {
                    let remarksText = document.createElement('p');
                    remarksText.innerHTML =  element2.text;
                    remarksText.classList.add('detail__remarks-text');
                    remarksItem.append(remarksText);
                  }

                  remarksList.append(remarksItem);
                });
                remarks.append(remarksList);
              }
              elemItem.append(remarks);
            }
            
            contentList.append(elemItem);
            }
          });

          if (id != '') {
            scrollDown(id);
          }

          contentList.scrollTop = 0;
        }

        if (tagDescription) {
          if (jsTagDetails.length > 0) {
            tagDescription.classList.add('active');
            tagDescription.innerHTML = '';

            jsTagDetails.forEach((element:any) => {
              let baseElem = document.createElement('li');
              baseElem.classList.add('detail__tagdescription-item');
              
              let tagElem = document.createElement('span');
              tagElem.classList.add('detail__tag', 'detail__tag--simple');
              if (element.addclass && element.addclass.length > 0) {
                tagElem.classList.add(...element.addclass);
              }
              tagElem.innerHTML = element.name;
              baseElem.append(tagElem);

              let detailElem = document.createElement('p');
              detailElem.classList.add('detail__tagdescription-details');
              detailElem.innerHTML = element.description;
              baseElem.append(detailElem);

              tagDescription.append(baseElem);
            });
          } else {
            tagDescription.classList.remove('active');
          }
        }
      })
      .catch( error => {
        console.error(error);
      })
    ;
  }

  function getPosts(category:string, resultItem:any, resultList:any, resultItemSp:any, resultListSp:any, resultValueSp:any) {
    jsonFileContents.getByCategory(category)
      .then(jsonData => {
        resultList.innerHTML = '';
        resultListSp.innerHTML = '';
        if (jsonData[0].displayname != '' && jsonData[0].displayname != null) {
          resultValueSp.innerHTML = jsonData[0].displayname;
        } else {
          resultValueSp.innerHTML = jsonData[0].name;
        }

        // PC Display
        jsonData.forEach( (element:any) => {
          let url = resultItem.querySelector('a');
          if (url) {
            url.removeAttribute('href');
            if (element.displayname != '' && element.displayname != null) {
              url.innerHTML = element.displayname;
            } else {
              url.innerHTML = element.name;
            }
          }
          let temp = resultItem.cloneNode(true) as HTMLElement;
          temp.addEventListener('click', function () {
            scrollDown(element.id);
             // Update Url
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('categ', category);
            urlParams.set('id', element.id);
            window.history.replaceState(null, '', '?' + urlParams.toString());
          });
          resultList.append(temp);

          // SP Display
          if (element.displayname != '' && element.displayname != null) {
            resultItemSp.innerHTML = element.displayname;
            resultItemSp.setAttribute('value', element.displayname);
          } else {
            resultItemSp.innerHTML = element.name;
            resultItemSp.setAttribute('value', element.name);
          }
          temp = resultItemSp.cloneNode(true) as HTMLElement;
          temp.addEventListener('click', function () {
            scrollDown(element.id);
             // Update Url
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('categ', category);
            urlParams.set('id', element.id);
            window.history.replaceState(null, '', '?' + urlParams.toString());
          });
          resultListSp.append(temp);
        });

        // Change url
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.set('categ', category);
        urlParams.set('id', jsonData[0].id);
        window.history.replaceState(null, '', '?' + urlParams.toString());

        window.scrollTo(0, 0);

        //@ts-ignore
        new SimpleBar(resultListSp, { autoHide: false } );
      })
      .catch( error => {
        console.error(error);
      })
    ;
  }
  
  if (jsonFileContents) {
    const baseUrl = window.location.href;
    let params = baseUrl.substring((baseUrl.indexOf('?') + ('?').length), baseUrl.length) as any;
    let paramsArray = [] as any;
    
    params = params.split('&');
    params.forEach( (element:any) => {
      const [key, value] = element.split('=');
      if ( !paramsArray[key] ) {
        paramsArray[key] = [];
      }
      paramsArray[key] = decodeURIComponent(value);
    });

    if (paramsArray.id && paramsArray.categ) {
      // Category display
      const selectValueField = document.querySelector('.js-category-current');
      const selectValueList =  document.querySelector('.js-category-list'); 
      const selectValueItem = document.querySelector('.js-category-item') as HTMLInputElement;
      const resultList = document.querySelector('.js-result-list');
      const resultItem = document.querySelector('.js-result-item');
      const resultListSp = document.querySelector('.js-resultselect-list');
      const resultItemSp = document.querySelector('.js-resultselect-item');
      const resultValueSp = document.querySelector('.js-resultselect-value');
      const contentList = document.querySelector('.js-content-list');

      // Category display
      if (selectValueField && selectValueList && selectValueItem) {
        selectValueField.innerHTML = paramsArray.categ;

        jsonFileContents.getContents('category')
          .then( jsonData => {
            selectValueList.innerHTML = '';

            jsonData.forEach( (element:any) => {
              if (element.displayname != '' && element.displayname != null) {
                selectValueItem.setAttribute('value', element.displayname);
                selectValueItem.innerHTML = element.displayname;
              } else {
                selectValueItem.setAttribute('value', element.name);
                selectValueItem.innerHTML = element.name;
              }
              
              let temp = selectValueItem.cloneNode(true) as HTMLElement;
              temp.addEventListener('click', function () {
                if (resultList && resultItem && resultListSp && resultItemSp && resultValueSp) {
                  getPosts(element.name, resultItem, resultList, resultItemSp, resultListSp, resultValueSp);
                }

                setTimeout(() => {
                  if (contentList) {
                    setContent(element.name, contentList);
                  }
                }, 1000);
              });
              selectValueList.append(temp);
            });

            //@ts-ignore
            new SimpleBar(selectValueList, { autoHide: false } );
          })
          .catch( error => {
            console.error(error);
          })
        ;
      }

      // Post by category display
      if (resultList && resultItem && resultListSp && resultItemSp && resultValueSp) {
        getPosts(paramsArray.categ, resultItem, resultList, resultItemSp, resultListSp, resultValueSp);
      }

      // Content Display
      if (contentList) {
        setContent(paramsArray.categ, contentList, paramsArray.id);
      }
    }
  }
};

export default detailLoader;
